
const data = {
    token_telegram_bot: '7362375172:AAG2BI-JdQk1nL8dzEgUUa0EFBnvUuhhWdk',
    id_chat: '-4595817215'
}

export { data };